import { motion } from "framer-motion";

/**
 * Cartolina "Buon Natale, famiglie!" — appare sotto il calendario il 25 dicembre.
 * NON è una casella: è il saluto di chiusura del percorso.
 * Usata sia nella pagina pubblica sia come anteprima nell'admin.
 */
export default function ChristmasCard({ imageUrl = "", message = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-md mx-auto mt-16"
      data-testid="christmas-card"
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt="Buon Natale, famiglie! — Con cura, Teresa Vilardo"
          className="w-full h-auto rounded-3xl shadow-xl"
        />
      )}
      {message && (
        <div className="bg-white/80 backdrop-blur rounded-2xl px-6 py-5 mt-4 border border-[#FF2768]/15 text-center">
          <p className="font-editorial italic text-lg text-[#3D2140] leading-relaxed whitespace-pre-line" data-testid="christmas-card-message">
            {message}
          </p>
        </div>
      )}
    </motion.div>
  );
}
